import { useEffect, useCallback } from 'react';
import type { SubmitEvent } from './useMessageSubmission';

interface UseUrlMessageHandlerProps {
  isSubmitting: boolean;
  input: string;
  setInput: (input: string) => void;
  triggerSubmit: (e?: SubmitEvent | React.FormEvent) => void;
}

export const useUrlMessageHandler = ({
  isSubmitting,
  input,
  setInput,
  triggerSubmit
}: UseUrlMessageHandlerProps) => {
  
  const handleUrlMessage = useCallback(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const messageParam = urlParams.get('message');
    
    if (messageParam && !isSubmitting && !input.trim()) {
      setInput(messageParam);
      setTimeout(() => {
        triggerSubmit();
      }, 100);
    }
  }, [isSubmitting, input, setInput, triggerSubmit]);

  useEffect(() => {
    handleUrlMessage();
  }, [handleUrlMessage]);

  return { handleUrlMessage };
};